var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLineVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 189,
    viewBox: "0 0 246 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-23 162.577C-1.99686 170.084 46.2447 175.78 49.5265 126.075C59.0435 67.0496 51.8237 55.7883 92.8454 60.0599C148.222 65.8262 165.903 93.0557 196.611 0.930664",
    stroke: "url(#paint0_linear_451_287)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-23 181.534C4.4441 191.352 67.4798 198.8 71.7679 133.8C84.2035 56.6139 74.7696 41.8876 128.371 47.4734C181.973 53.0593 215.412 56.3664 245 0",
    stroke: "url(#paint1_linear_451_287)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_451_287",
    x1: -23,
    y1: 31.4684,
    x2: 147.913,
    y2: 148.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_451_287",
    x1: -23,
    y1: 34.4616,
    x2: 174.895,
    y2: 180.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLineVector);
export default __webpack_public_path__ + "static/media/new_line_vector.65e2e6f10e1bd2aa26071d87acb806cb.svg";
export { ForwardRef as ReactComponent };